/* eslint-disable class-methods-use-this */
/* eslint-disable max-statements */
/* eslint-disable indent */
import Base from "../Base";
export default class Governance extends Base {
  init(elMain, locale) {
    console.log(":: governance ::");

    const main = document.querySelector("main.governance_group");
    const modal = document.querySelector(".popup-modal");
    const modalBg = modal.querySelector(".bg");
    const modalCloseBtns = modal.querySelectorAll(".close-btn");

    addCardsListeners();

    modalBg.addEventListener("click", closeModal);
    for (let i = 0; i < modalCloseBtns.length; i++) {
      modalCloseBtns[i].addEventListener("click", closeModal);
    }

    function addCardsListeners() {
      const cards = main.querySelectorAll(".single-member");

      if (cards.length) {
        for (let i = 0; i < cards.length; i++) {
          cards[i].addEventListener("click", onCardClick);
        }
      }
    }

    function onCardClick(e) {
      const target = e.currentTarget;
      modal.querySelector(".title").innerHTML = target.querySelector(
        ".single-member__name"
      ).innerHTML;
      modal.querySelector(".subtitle").innerHTML =
        target.querySelector(".subtitle").innerHTML;
      modal.querySelector(".wysiwyg-container").innerHTML =
        target.querySelector(".content").innerHTML;
      showModal();
    }

    function showModal() {
      modal.style.display = "flex";
    }

    function closeModal() {
      modal.style.display = "none";
      modal.querySelector(".wysiwyg-container").innerHTML = "";
    }
  }
}
